import classNames from 'classnames';
import { LineItem } from 'types/entity/cart';
import OrderItem from './OrderItem';

type OrderItemsListProps = {
  className?: string;
  lineItems: LineItem[];
};

const OrderItemsList: React.FC<OrderItemsListProps> = ({ lineItems, className }) => {
  return (
    <div className={classNames('flex flex-col divide-y', className)}>
      {lineItems.map((lineItem) => (
        <OrderItem key={lineItem.lineItemId} lineItem={lineItem} />
      ))}
    </div>
  );
};

export default OrderItemsList;
